"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.H1Icon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("../withSVGIcon");
var Icon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#000' : _b;
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx("path", { d: "M6.23748 19H8.39018V14.794H12.7602V19H14.9079V8.81818H12.7602V13.0192H8.39018V8.81818H6.23748V19ZM21.0528 8.81818H19.0294L16.5088 10.4141V12.3232L18.8405 10.8615H18.9001V19H21.0528V8.81818Z", fill: fill }, void 0) }, void 0));
};
exports.H1Icon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 28 28' });
//# sourceMappingURL=H1Icon.js.map